export default __webpack_public_path__ + "static/media/mixedgases-temp.64dcc8ac.jpg";